/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - Territory Management
=========================================================
*/

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useEffect, useState } from "react";
import useDealer from "hooks/useDealer";

export default function data() {
  const { nonApprovedDealers, nonActiveDealers, DealerStatusApprove } = useDealer();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState({});

  const DealerActions = ({ dealerId }) => (
    <MDBox display="flex" justifyContent="center">
      <MDButton
        variant="contained"
        color="info"
        onClick={() => {
          DealerStatusApprove(dealerId).then((res) => {
            if (res.success) {
              alert("Approved successfully");
              fetchList();
            }
          });
        }}
        disabled={loading[dealerId]?.delete}
      >
        Approve
      </MDButton>
    </MDBox>
  );

  const DealerInfo = ({ name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{email}</MDTypography>
      </MDBox>
    </MDBox>
  );

  const fetchList = async () => {
    await nonApprovedDealers();
  };

  useEffect(() => {
    if (nonActiveDealers.dealers) {
      setData(nonActiveDealers.dealers);
    }
  }, [nonActiveDealers]);

  const rows = data?.map((dealer, index) => ({
    name: <DealerInfo key={index} name={dealer?.name} email={dealer?.email} />,
    phoneNumber: `${dealer?.phoneNumber}`,
    bussinessName: dealer?.bussinessName || "N/A",
    gstNo: dealer.gstNo,
    town: dealer.town,
    actions: <DealerActions dealerId={dealer._id} />,
  }));

  return {
    columns: [
      { Header: "Name", accessor: "name", align: "left" },
      { Header: "Phone Number", accessor: "phoneNumber", align: "left" },
      { Header: "Bussiness Name", accessor: "bussinessName", align: "left" },
      { Header: "GST No", accessor: "gstNo", align: "left" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ],
    rows,
  };
}
